export const BIRouterName = {
  /** BI登录 */
  BILogin: '/bi/login',
  /** BI监管方大屏 */
  BIManageScreen: '/bi/home/manage_screen',
  /** BI监管方实时监控 */
  BIManageRealtimeMonitor: '/bi/home/manage_realtime_monitor',
  /** BI监管方实时监控大屏 */
  BIManageRealtimeMonitorFull: '/bi/home/manage_realtime_monitor_full',
  /** BI供方实时监控大屏 */
  BISupplyRealtimeMonitor: '/bi/home/supply_realtime_monitor',
  /** BI供方实时监控大屏 */
  BISupplyRealtimeMonitorFull: '/bi/home/supply_realtime_monitor_full',
  /** BI供方现场监控 */
  BISupplyLiveMonitor: '/bi/home/supply_live_monitor',
  /** BI供方现场监控大屏 */
  BISupplyLiveMonitorFull: '/bi/home/supply_live_monitor_full',
  /** BI需方大屏 */
  BIPurchaserScreen: '/bi/home/purchaser_screen',
  /** BI需方明厨亮灶 */
  BIPurchaserBrightKitchen: '/bi/home/purchaser_bright_kitchen',
  /** BI需方明厨亮灶大屏 */
  BIPurchaserBrightKitchenFull: '/bi/home/purchaser_bright_kitchen_full',
  /** BI监管方采购汇总 */
  BIManagePurchaseReport: '/bi/home/manage_purchase_report',
  /** BI监管方财务汇总 */
  BIManageFinanceReport: '/bi/home/manage_finance_report',
  /** BI监管方食安汇总 */
  BIManageFoodSafeReport: '/bi/home/manage_food_safety_report',
  /** BI需方采购汇总 */
  BIPurchaserPurchaseReport: '/bi/home/purchaser_purchase_report',
  /** BI需方财务汇总 */
  BIPurchaserFinanceReport: '/bi/home/purchaser_finance_report',
  /** BI供方采购汇总 */
  BISupplyPurchaseReport: '/bi/home/supply_purchase_report',
  /** BI供方财务汇总 */
  BISupplyFinanceReport: '/bi/home/supply_finance_report',
};
